
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'HomeStatus',
  props: {
    status: String
  },
  setup(props) {
    interface Props {
      status: string
    }
    const propObj = props as Props;
    const config = propObj.status;
    return {
      config
    };
  }
});
